/* Fashion CITY — 색상 견본 사진 가볍게 만들기
   색상 견본은 화면에서 50px 정도로만 보이는데 원본은 150KB 짜리라서
   18색이면 2.7MB 나 됩니다. 쇼피파이 CDN 의 ?width= 기능으로 줄여서 불러옵니다.
   (원본 사진은 그대로, 옆의 큰 사진과 주문에 붙는 목업은 원본 화질 그대로입니다.)
*/
(function () {
  'use strict';
  var W = 240;

  function small(u) {
    if (!u || u.indexOf('width=') > -1) return u;
    if (u.indexOf('cdn.shopify.com') < 0) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + W;
  }

  function fix() {
    var imgs = document.querySelectorAll('[data-fcpo-caps] img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.getAttribute('data-fcpo-small')) continue;
      im.setAttribute('data-fcpo-small', '1');
      im.removeAttribute('loading');
      im.setAttribute('decoding', 'async');
      var s = im.getAttribute('src');
      var n = small(s);
      if (n !== s) im.setAttribute('src', n);
    }
  }

  function start() {
    fix();
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();